// src/utils/workflowUtils.js
export function updateWorkflow(workflow, subscription_id) {
  if (!subscription_id) return workflow;

  const updatedWorkflow = [...workflow];

  updatedWorkflow.forEach((step, index) => {
    const suffix = `${subscription_id}/`;
    if (step.fileUrl && !step.fileUrl.endsWith(suffix)) {
      updatedWorkflow[index].fileUrl = `${step.fileUrl}${suffix}`;
    }
    if (step.fileUploadUrl && !step.fileUploadUrl.endsWith(suffix)) {
      updatedWorkflow[index].fileUploadUrl = `${step.fileUploadUrl}/${suffix}`;
    }
  });

  return updatedWorkflow;
}

export const STUNM_STORAGE_KEYS = [
  "isLoggedIn",
  "isApproverLoggedIn",
  "brainStormFlag",
  "buttonBrainStormBackground",
  "displayBrainStorm",
  "displayCampaignBreif",
  "profile",
  "email",
  "subscription_id",
  "token",
  "user_type",
  "user_type_new",
  "approverId",
  "loggedInUserId",
  "campaignId",
  "summaryDataForApprover",
  "summaryDataForCmo",
  "summaryDataForCmoOfferings",
  "subscriptionTier",
  "isSubscribed",
];

export function clearStunMStorage() {
  if (typeof window === "undefined") return;

  for (const key of STUNM_STORAGE_KEYS) {
    window.localStorage.removeItem(key);
  }

  for (const key of Object.keys(window.sessionStorage)) {
    if (key.startsWith("msal.")) {
      window.sessionStorage.removeItem(key);
    }
  }
}
